import { Component, inject } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { InvoicePaymentMethod } from 'app/core/model/invoice-payment-method';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-confirmation-payment-method-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Invoice Payment Method</h2>
        </div>
        <div class="flex-fill d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <dx-form *ngIf="invoicePaymentMethod" [formData]="invoicePaymentMethod" validationGroup="invoicePaymentMethodValidationGroup">
                        <dxi-item itemType="group">
                            <dxi-item dataField="name" [isRequired]="true"></dxi-item>
                            <dxi-item dataField="quickBooksPaymentMethod" [isRequired]="true"></dxi-item>
                            <dxi-item dataField="isFloorplanMethod"></dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    standalone: false
})
export class InvoicePaymentMethodDialogComponent {
    appInfo = inject(AppInformationService);
    uow = inject(GenesisUnitOfWork);

    result = new Subject<{ success: boolean }>();
    invoicePaymentMethod: InvoicePaymentMethod;
    displayOrder: number;

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.invoicePaymentMethod)
            this.invoicePaymentMethod = this.uow.invoicePaymentMethods.createEntity({
                displayOrder: this.displayOrder,
            }) as InvoicePaymentMethod;
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('invoicePaymentMethodValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('invoicePaymentMethodValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
